import { ReactElement } from 'react';
import { Outlet } from 'react-router-dom';

import { PaymentsMainView } from 'features/offers';
import { PrivateRoute } from 'app/routes';
import { Whatsapp } from 'components';

const OffersLayout = (): ReactElement => {
  return (
    <PrivateRoute redirectIfNotLogged={false}>
      <Whatsapp />

      <PaymentsMainView>
        <Outlet />
      </PaymentsMainView>
    </PrivateRoute>
  );
};

export default OffersLayout;
